import React from "react";
import { useLocation } from "react-router";
import { Svg } from "assets";

export const SortButton = ({ Icon, className, openDrawer }) => {
  const location = useLocation();
  const info = location?.state;

  return (
    <button
      className={`sort-by-button ${
        info?.sortType ? "sort-by-button-active" : ""
      } ${className ? className : ""}`}
      onClick={openDrawer}
    >
      {Icon ? <Icon /> : <Svg.Sort2Svg />}
    </button>
  );
};
